import { Component } from '@angular/core';
import { NavParams, AlertController } from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';

@Component({
	selector: 'projectinfo',
  templateUrl: 'projectinfo.html'
})
export class ProjectInfo {
	public loading;
	projectinfo:any=[];
	constructor(public params: NavParams,public global: AppState,private alertCtrl: AlertController) {
		this.projectinfo =  params.data;
	}
	
	showXmCy(xm:string){
		let alert = this.alertCtrl.create({
		    title: '项目成员',
		    subTitle: xm,
		    buttons: ['确认']
		  });
		  alert.present();
	}
	
	//下拉刷新
  	doRefresh(refresher){
  	  	setTimeout(() => {
    	 	refresher.complete();
  	  	}, 1000);
  	}
  
  	//上拉加载
	loadMore(refresher){
		setTimeout(() => {
	      	refresher.complete();
	  	}, 500);
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/research/project/detail/projectinfo.ts